module.exports = __webpack_public_path__ + "img/Sourcefile - Ai File.jpg";